import { FallbackProps } from "react-error-boundary"
import { Translation } from "react-i18next"
import { TFunction } from "i18next"
import { Button } from "~/design-system"
import { ServerError } from "~/api/errors"

const ErrorBoundary = ({ error, resetErrorBoundary }: FallbackProps) => {
  const status = isServerError(error) ? error.status : undefined

  const dismissError = () => {
    window.location.href = "/"
    resetErrorBoundary()
  }

  return (
    <div className="px-large flex h-screen items-center justify-center">
      <div className="max-w-[600px]">
        <div>
          <div>
            {status && (
              <p className="text-ui-fg-smooth txt-small-regular-semibold opacity-75">
                {status}
              </p>
            )}
            <h1 className="txt-large-bold mb-xsmall">
              <Translation>
                {(t) => errorMessage(t, status)}
              </Translation>
            </h1>
            <p className="txt-base-regular text-ui-fg-subtle">
              <Translation>
                {(t) => errorDescription(t, status)}
              </Translation>
            </p>
          </div>

          <div className="mt-xlarge flex w-full  items-center">
            <Button
              size="small"
              variant="primary"
              onClick={dismissError}
            >
              <Translation>
                {(t) =>
                  t("Back to dashboard")
                }
              </Translation>
            </Button>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  )
}

const isServerError = (error: any): error is ServerError => {
  return error["status"] !== undefined
}

const errorDescription = (t: TFunction, status?: number) => {
  const defaultDescription = t(
    "An error occurred with unspecified causes, this is most likely due to a techinical issue on our end. Please try refreshing the page. If the issue keeps happening, contact your administrator."
  )

  if (!status) {
    return defaultDescription
  }
}

const errorMessage = (t: TFunction, status?: number) => {
  const defaultMessage = t("An unknown error occured")

  if (!status) {
    return defaultMessage
  }

  const message = {
    400: t("Bad request"),
    401: t("You are not logged in"),
    403: t("You do not have permission to perform this action"),
    404: t("Page was not found"),
    500: t("An unknown server error occured"),
    503: t("Server is currently unavailable"),
  }[status]

  return message || defaultMessage
}

export default ErrorBoundary